import { useState } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import useApiFetch from '@/hooks/useApiFetch';
import teamsApi from '@/services/teams';
import { chakraExtendedTheme } from '@/styles/theme';
import { PaginationProps } from '@/trio-ui/Pagination/Pagination.component';
import { FetchApiIds } from '@/types';
import { Team } from '@/types/api';
import TeamsComponent from './Teams.component';

const Teams = (): JSX.Element => {
  const [isAddNewMemberModalOpen, setIsAddNewMemberModalOpen] = useState<boolean>(false);
  const [search, setSearch] = useState<string>('');
  const [pagination, setPagination] = useState<
    Pick<PaginationProps, 'currentPage' | 'itemsPerPage'>
  >({
    currentPage: 1,
    itemsPerPage: 10,
  });
  const [editingTeam, setEditingTeam] = useState<Team>();

  const {
    data: teamsData,
    isLoading: isLoadingTeams,
    refetch: refreshTeams,
  } = useApiFetch(
    [FetchApiIds.GET_ALL_TEAMS, pagination.currentPage, pagination.itemsPerPage, search],
    async () =>
      teamsApi.getAllTeams({
        page: pagination.currentPage,
        take: pagination.itemsPerPage,
        term: search,
      })
  );

  const handleChangePageHandler = (page: number): void => {
    setPagination((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };

  const handleChangeRecordsPerPage = (records: number): void => {
    setPagination((prev) => ({
      ...prev,
      itemsPerPage: records,
    }));
  };

  const handleCreateTeamClick = (): void => {
    setEditingTeam(undefined);
    setIsAddNewMemberModalOpen(true);
  };

  const handleEditTeam = (team: Team): void => {
    setEditingTeam(team);
    setIsAddNewMemberModalOpen(true);
  };

  return (
    <ChakraProvider theme={chakraExtendedTheme}>
      <TeamsComponent
        teams={teamsData?.teams.data}
        isLoading={isLoadingTeams}
        onChangePageHandler={handleChangePageHandler}
        onChangeRecordsPerPage={handleChangeRecordsPerPage}
        count={teamsData?.teams.count || 0}
        lastPage={teamsData?.teams.lastPage || 1}
        search={search}
        onSearchChange={setSearch}
        isAddNewMemberModalOpen={isAddNewMemberModalOpen}
        onCloseNewMemberModal={() => setIsAddNewMemberModalOpen(false)}
        onAddNewTeamClick={handleCreateTeamClick}
        refreshTeamsList={refreshTeams}
        onEditTeamClick={handleEditTeam}
        editingTeam={editingTeam}
        {...pagination}
      />
    </ChakraProvider>
  );
};

export default Teams;
